var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"pointer",attrs:{"src":require("../assets/img/contact_support_opsz20.svg"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }